'use client';

import { PlasmicRootProvider } from '@plasmicapp/loader-nextjs';
import { PLASMIC } from './plasmic-init';
import { Component } from 'react';
import './register-components'; // Must include this import

// Global flag to track if Plasmic provider is available
let plasmicProviderFailed = false;

export const isPlasmicProviderFailed = () => plasmicProviderFailed;

// Safe wrapper that catches errors during initialization
class SafePlasmicProvider extends Component<
  Omit<React.ComponentProps<typeof PlasmicRootProvider>, 'loader'>
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    plasmicProviderFailed = true;
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    plasmicProviderFailed = true;
    console.error('[Plasmic] Provider failed:', error.message);
    console.error('[Plasmic] Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // Render children without Plasmic provider
      return this.props.children;
    }

    try {
      return <PlasmicRootProvider loader={PLASMIC} {...this.props} />;
    } catch (error) {
      plasmicProviderFailed = true;
      if (process.env.NODE_ENV === 'development') {
        console.warn('PlasmicRootProvider render error:', error);
      }
      return this.props.children;
    }
  }
}

export function PlasmicClientRootProvider(
  props: Omit<React.ComponentProps<typeof PlasmicRootProvider>, 'loader'>
) {
  return <SafePlasmicProvider {...props} />;
}
